import Loader from "react-loader-spinner";
import { faBookmark, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, FormGroup, Modal } from "react-bootstrap";
import { CheckLg, DashCircle, Trash } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { saveAccountCheckDescription, getAccountCheckDescriptionInfo, deleteAccountCheckDescription } from "../store/api/DocumentsAPI";
import { useEffect, useState } from "react";
import { translateError } from "../../store/api/CommonFunctions";

const ModalAccountCheck = (props) => {
    const [checkInfo, getCheckInfo] = useState({});
    const { popData, setPopData } = props;
    const [submitError, setSubmitError] = useState({});
    const { show, checkType, relationID, accountCat, onSave } = popData;
    const { register, handleSubmit } = useForm();
    function close() {
        setPopData({
            show: false
        })
        if(submitError.Error)
        {
            setSubmitError({});
        }
    }
    function save(data) {
        const err = {};
        if (!checkType) {
            err.Error = "نوع مرجع توضیحات تعیین نشده است";
        }
        if (!relationID) {
            err.Error = "مرجع توضیحات تعیین نشده است";
        }
        if (data.CheckDescription === "" && data.CheckColor === "") {
            err.Error = "حداقل یکی از دو مورد توضیحات یا رنگ الزامی است";
        }
        setSubmitError(err);
        if (Object.keys(err).length > 0) {
            return;
        }
        data.CheckType = checkType;
        data.RelationID = relationID;
        data.AccountCat = accountCat;
        const onSuccess = (res) => {
            if (res.Error) {
                res.Error = translateError(res.Error);
                setSubmitError(res);
            }
            else {
                if(onSave)
                {
                    onSave(res);
                }
                setPopData({
                    show: false
                })
            }

        }
        saveAccountCheckDescription(data, onSuccess);
    }
    function deleteDesc()
    {
        const onSuccess = (res) => {
            if (res.Error) {
                res.Error = translateError(res.Error);
                setSubmitError(res);
            }
            else {
                if(onSave)
                {
                    onSave(res);
                }
                setPopData({
                    show: false
                })
            }

        }
        deleteAccountCheckDescription(relationID, checkType, onSuccess);
    }
    useEffect(() => {
        if (show) {
            getAccountCheckDescriptionInfo(checkType, relationID, getCheckInfo);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle" >
                <span>
                    <FontAwesomeIcon icon={faBookmark} size="lg" /> &nbsp;
                    توضیحات ردیف
                </span>
                <span>
                    <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
                </span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {
                    submitError?.Error && <small className="errors">{submitError.Error}</small>
                }
                {checkInfo === "PENDING" && <Loader type="BallTriangle" width={20} height={20} color="#bb1370" />}
                {checkInfo !== "PENDING" &&
                    <form onSubmit={handleSubmit(save)}>
                        <FormGroup>
                            <label>شرح ردیف: </label>
                            <Form.Control as="textarea" rows={3} name="CheckDescription" ref={register({})} defaultValue={checkInfo?.CheckDescription ?? ""} />
                        </FormGroup>
                        <FormGroup>
                            <label>رنگ ردیف:</label>
                            <input className="form-control" type="color" defaultValue={checkInfo?.CheckColor ?? "#2B74AB"} name="CheckColor" ref={register({})} />
                        </FormGroup>
                        <Button type="submit" variant="info" className="group-Btn mt-2"><CheckLg size={18} />&nbsp;ثبت توضیحات</Button>
                        <Button variant="danger" className="group-Btn mt-2" onClick={deleteDesc}><Trash size={18} />&nbsp;حذف توضیحات</Button>
                    </form>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalAccountCheck;